import React, { useEffect } from "react";
import { StabilityDepositManager } from "../components/Stability/StabilityDepositManager";
import { Info } from "../components/Stability/PSY/Info";
import { CollateralLexicons } from "src/lexicon";
import BackArrow from "src/assets/images/back_arrow.svg"
import { Link, useParams } from "react-router-dom";
import { useAppState } from "../hooks/AppStateContext";

export const StabilityPool: React.FC = () => {
  const { spAddress } = useParams();

  const { updateSpAddress, currentCollateralKey } = useAppState();
  useEffect(() => {
    updateSpAddress(spAddress);
  }, [spAddress, updateSpAddress]);
  const lexicon = CollateralLexicons.find(lexicon => lexicon.key === currentCollateralKey)

  return (
    <div className="w-full h-full overflow-y-scroll md:mt-10">
      <div className="flex flex-row items-cener">
        <Link to="/stability-pools" className="flex flex-row">
          <img src={BackArrow} alt="back" className="mr-4" />
        </Link>
        <img src={lexicon?.iconUrl} alt={lexicon?.term} className="mr-3 w-8 h-8" />
        <span className="text-style-title">{lexicon?.term} Stability Pool</span>
      </div>
      <div className="grid md:gid-rows-stability-pool md:grid-cols-stability-pool gap-5 w-full mt-8">
        <div className="row-span-2 col-span-1">
          {!!spAddress && !!currentCollateralKey && (
            <StabilityDepositManager spAddress={spAddress} collateralKey={currentCollateralKey}/>
          )}
        </div>
        <div className="row-span-1 col-span-1">
          <Info />
        </div>
      </div>
    </div>
  )
}
